import * as React from "react";
import { useHistory } from "react-router";

import useWaitApiCall from "../../../hooks/useWaitApiCall";
import {
  authenticationPath,
  clearErrorMessage,
  clearOTT,
  Context,
  login,
} from "../../../managerStore";
import LoginForm from "../../../templates/manager/LoginForm";

export default () => {
  const { dispatch, state } = React.useContext(Context);
  const history = useHistory();
  const [calling, peep] = useWaitApiCall(state);
  const loginFunc = React.useCallback(
    (email: string, password: string) => {
      dispatch(peep(login(email, password)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    if (state.ott) {
      history.push(`${authenticationPath}/${state.ott}`);
      dispatch(clearOTT());
    }
  }, [dispatch, history, state.ott]);

  React.useEffect(() => {
    return () => dispatch(clearErrorMessage());
  }, [dispatch]);

  return <LoginForm calling={calling} login={loginFunc} error={state.error} />;
};
